import LargeModal from "../../../component/LargeModel";
import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import axios from "axios";
import {ApiUrl} from "../../../auth/authMethods";
import AlertMsg from "../../../component/AlertMsg/AlertMsg";
import sleep from "../../../utils/sleep";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import CancelIcon from '@mui/icons-material/Cancel';

const Impersonate = ({item}) => {
    const [lgShow, setLgShow] = useState(false);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false);
    const [sent, setSent] = useState(false);

    const buttonText = <>
        <ForwardToInboxIcon fontSize="medium"/>
        &nbsp; Reenviar boas vindas
    </>;

    const iconSpan = (
        <ForwardToInboxIcon style={{fontSize: 100}} id="icon-svg"/>
    );

    const handleSubmit = (e) => {
        e.preventDefault();

        setError(false)
        setLoading(true)

        axios.put(ApiUrl + "/user/resend-welcome/" + item.id)
            .then(() => {
                setSent(true)
            })
            .catch((error) => {
                console.log(error);
                setError(true)
            }).finally(() => {
            setLoading(false)
        })
    };

    useEffect(() => {
        if (sent) {
            sleep(2 * 1000).then(() => {
                setSent(false)
            })
        }
    }, [sent]);

    return (
        <>
            <LargeModal
                buttonClass={"dropdown-item"}
                buttonText={buttonText}
                title={`Realmente deseja reenviar o "boas vindas" para: ${item.username}?`}
                iconSpan={iconSpan}
                lgShow={lgShow} setLgShow={setLgShow}
                buttonId={"links-action"}
            >
                <div className="message-container">
                    <span><b>Atenção</b></span>
                    <hr/>
                    <div className="message-content">
                        <p>
                            Ao confirmar esta ação, será gerada uma nova senha para este usuário e tanto o email quanto
                            o whatsapp (caso possua número cadastrado) de boas vindas serão reenviados.
                        </p>
                    </div>
                    <hr/>
                </div>

                {error && <div className='text-center'>
                    <AlertMsg/>
                </div>}
                <div>
                    <Form onSubmit={handleSubmit} className="form-inputs">

                        <LoadingButton
                            onClick={handleSubmit}
                            loading={loading}
                            loadingPosition="start"
                            startIcon={<SendIcon/>}
                            // color={color}
                            variant="contained"
                            type='submit'
                        >
                            <span>
                                Confirmar Reenvio
                            </span>
                        </LoadingButton>
                    </Form>
                </div>
                {sent &&
                    <div className="text-success text-center mt-2">
                        <CheckCircleIcon className="pe-1"/>
                        Enviado com sucesso!
                    </div>
                }
                {error &&
                    <div className="text-danger text-center mt-2">
                        <CancelIcon className="pe-1"/>
                        Erro no envio, tente novamente mais tarde ou contate um administrador
                    </div>
                }
            </LargeModal>
        </>
    );
};

export default Impersonate;
